import ContactPage from '../../src/pages/ContactPage'

/** SSR page: renders ContactPage inside ShopChromeLayout so its content is crawlable. */
export default function ContactPageSsr() {
  return <ContactPage />
}
